import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import PublicPageShell from '../components/PublicPageShell';

const importantLinks = [
  { label: 'Home', path: '/' },
  { label: 'Pricing', path: '/pricing' },
  { label: 'Modules', path: '/modules' },
  { label: 'Plans', path: '/plans' },
  { label: 'Industries', path: '/industries' },
  { label: 'Contact', path: '/contact' },
];

const NotFound = () => (
  <PublicPageShell mainClassName="pt-20">
    <section className="relative overflow-hidden bg-black">
      <div className="hero-grid absolute inset-0 pointer-events-none" />
      <div className="relative mx-auto max-w-[980px] px-5 py-16 md:px-[7.6923%] md:py-24">
        <p className="mb-4 text-sm font-semibold uppercase text-[#00FFD1]">
          404
        </p>
        <h1 className="text-4xl font-semibold leading-tight text-white md:text-6xl">
          Page not found
        </h1>
        <p className="mt-6 max-w-2xl text-base leading-8 text-white/64 md:text-lg">
          This Webouse page does not exist or may have moved. Use the links
          below to return to the main website, compare packages or contact the
          team about a project.
        </p>

        <div className="mt-8 grid gap-3 sm:grid-cols-2">
          {importantLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className="group flex items-center justify-between rounded-2xl border border-white/[0.08] bg-white/[0.03] px-5 py-4 text-white/72 transition-colors hover:border-[#00FFD1]/35 hover:text-white"
            >
              <span>{link.label}</span>
              <ArrowRight className="h-4 w-4 text-[#00FFD1] transition-transform group-hover:translate-x-1" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  </PublicPageShell>
);

export default NotFound;
